import { Workspace } from '../records/Workspace';
import { useFacets, fleetQuery } from '../search/hooks';
import { PageHeader } from './PageHeader';

export function DevicesPage() {
  const fleet = useFacets(fleetQuery);
  return (
    <Workspace mode="device" placeholder="Hostname, serial or ID — or “offline windows at Acme”"
      heading={<PageHeader title="Devices" description={fleet.data ? `${fleet.data.total} devices across ${fleet.data.organizations.length} customers` : 'Every device you can access'} />} />
  );
}

export function SearchPage() {
  return <Workspace mode="mixed" heading={<PageHeader title="Search" description="Customers, sites and devices you can access" />} />;
}
